import {GeneralCampaign} from "./campaign";

// src/app/models/chat.model.ts
export interface ChatMessage {
  id: string;
  senderId: number;
  message: string;
  createdAt: number;
  read: boolean;
  // ... add anything else you need
}

export interface User {
  id: number;
  name: string;
  profileImageUrl?: string;
}

export type ChatStatus = 'agent' | 'user' | 'bot'; // Example enum-like type

// export type ContentMessageType = 'Text' | 'Image' | 'Video' | 'Audio';

export type MessageStatus = 'Pending' | 'Sent' | 'Delivered' | 'Read' | 'Failed';

export interface MessageInterface {
  messageId?: string;              // "_id" from MongoDB
  conversationId: string;
  type: ChatStatus;                // Who sent the message
  messageType: ContentMessageType; // Text, Image, etc.
  content: string;                // Actual message or URL
  contentTranslated?: string;     // Translated message or URL
  datePending?: Date;           // ISO string to match UTC format
  dateSent?: Date;
  dateDelivered?: Date;
  dateRead?: Date;
  status?: MessageStatus;          // Status of message lifecycle
  timestamp?: Date;               // Keep for backward compatibility
  handlerType?: string;            // Identifier for the handler type
  agentId?: string | null;
  campaignId?: string | null;
  workspaceId?: string | null;
  targetScope?: string | null;
}

export interface MessageConversation extends MessageInterface {
  user: User;
}

export enum ConversationStatus {
  Active = "Active",
  Finish = "Finish",
  Pending = "Pending",
}

export interface ConversationMetada {
  getgeneralConfig?: GeneralCampaign; // General campaign settings
  // translationConfig?: TranslationConfig; // Translation settings

  // implement a get to translationConfig to parse correctly source and target languages actually the api return sourceLanguage and targetLanguage
  translationConfig?: {
    enable: boolean;
    sourceLanguage?: string; // Use string for raw API values
    targetLanguage?: string; // Use string for raw API values
    improveRedaction?: boolean; // Optional field for redaction improvement
  };
}

export interface Conversation {
  conversationId?: string;  // Equivalent to string? in C#
  keyPrefix?: string;
  startDate: Date;          // In C#, this property has a default value;
  clientId?: string;
  channelId?: string;
  platform?: string;
  workspaceId?: string;
  status: ConversationStatus;  // Modeled as an enum in TypeScript
  endDate: Date;
  acceptedDate?: Date;
  agentId?: string;
  agentName?: string;
  campaignId: string; // Campaign ID for the conversation
  targetScope?: string;
  ticketId?: string;
  metadata?: ConversationMetada; // Metadata for the conversation
  customVariables?: Record<string, string>;
  transferData?: TransferData;
  transferHistory?: TransferHistoryItem[]; // Add TransferHistory as direct property
}

export interface TransferHistoryItem {
  transferDate: string;
  fromAgentId: string;
  fromAgentName: string;
  toAgentId: string | null;
  toAgentName: string | null;
  toCampaign: string;
  transferReason: string;
}

export interface TransferData {
  isTransfer: boolean;
  transferByAgent: string;
  transferByCampaign: string;
}

export enum ContentMessageType {
  Text,
  Image,
  Video,
  Audio,
  Document, // for files like PDFs, Word documents, etc.
  Unsupported // Added for fallback
}


export interface FileMessage {
  filename: string;
  message: string;
  size: number;
  url: string;
}

export interface MessageTypeHandler {
  type: ContentMessageType; // Type of the message (Text, Image, etc.)
  processMessage(message: MessageInterface): void; // Method to process the message
}

export interface AgentState {
  label: string;
  value: string;
  description?: string;
  categoryId: string;
  color: string; // Add color property
  backgroundColor?: string; // Optional background color for enhanced styling
}

export const STATE_COLOR: { color: string, backgroundColor: string }[] = [
  { color: '#2ECC71', backgroundColor: 'rgba(46, 204, 113, 0.1)' }, // Success green
  { color: '#F39C12', backgroundColor: 'rgba(243, 156, 18, 0.1)' }, // Warning orange
  { color: '#3498DB', backgroundColor: 'rgba(52, 152, 219, 0.1)' }, // Info blue
  { color: '#5DADE2', backgroundColor: 'rgba(93, 173, 226, 0.1)' }, // Lighter blue for training
  { color: '#E74C3C', backgroundColor: 'rgba(231, 76, 60, 0.1)' }, // Danger red
  { color: '#9B59B6', backgroundColor: 'rgba(155, 89, 182, 0.1)' }, // Purple
  { color: '#F1C40F', backgroundColor: 'rgba(241, 196, 15, 0.1)' }, // Yellow
  { color: '#34495E', backgroundColor: 'rgba(52, 73, 94, 0.1)' } // Dark gray
]
